import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core'
import brightcovePlayerLoader from '@brightcove/player-loader'

import { Resource } from '@mprep/shared/data/models'

@Component({
  selector: 'mp-brightcove',
  templateUrl: './brightcove.html',
  styleUrls: ['./brightcove.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BrightcoveComponent implements OnInit {
  // playerId/videoId
  @Input()
  public videoResource: Resource

  @ViewChild('player')
  public player

  // MP-TODO: IMPLEMENT ME
  constructor() { }

  public ngOnInit() {
    const [playerId, videoId] = this._parseUri(this.videoResource.uri)

    brightcovePlayerLoader({
      refNode: this.player.nativeElement,
      accountId: '1107601866001',
      playerId: playerId,
      embedId: 'default',
      videoId: videoId
    })
  }

  private _parseUri(uri: string): string[] {
    return uri.split('/')
  }
}



// WEBPACK FOOTER //
// ./src/app/video-players/brightcove/brightcove.component.ts